import axios from 'axios'
import {
  ResponseObject,
  ResponseObjectCheckin,
  ResponseObjectPaginated,
  ResponseObjectURL,
  ResponseObjectUpload,
} from '../../../models'
import {GetCheckInListFilter} from '../features/checkInList/model/checkInList.model'
import {GuestModel} from '../features/guests/model'
import {ObjectIdModule} from '../features/modules/models'
import {
  CheckingModel,
  GetCheckingDto,
  GetListReservaCamaProductoTipoHuespedDto,
  ReservaCamaProductoTipoHuespedModel,
  SearchHuespedModel,
  createCheckIn,
  createPreCheckIn,
  createReserveBedProductTypeGuest,
} from '../models/ckecking.model'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createCheckinService(dto: createCheckIn) {
  return await axios.post<ResponseObjectCheckin>(`${BASEURL}/reserve/createCheckInReserve`, dto)
}

export async function createCheckinServiceList(dto: createPreCheckIn) {
  return await axios.post<ResponseObjectCheckin>(`${BASEURL}/reserve/createCheckInReserveList`, dto)
}


export async function createPreCheckinService(dto: createPreCheckIn) {
  return await axios.post<ResponseObjectCheckin>(`${BASEURL}/reserve/createPreCheckInReserve`, dto)
}

export async function createCheckoutService(dto: createCheckIn) {
  return await axios.post<ResponseObjectCheckin>(`${BASEURL}/reserve/createCheckOutReserve`, dto)
}

// export async function deleteCheckingService(dto: ObjectIdModule[]) {
//   return await axios.delete<ResponseObject<CheckingModel>>(`${BASEURL}/reserve/deleteReserve`, {
//     data: dto,
//   })
// }

export function getCheckingService(dto: GetCheckingDto) {
  return axios.post<ResponseObjectPaginated<CheckingModel[]>>(
    `${BASEURL}/reserve/postListBeds`,
    dto,
  )
}

export function getCheckingService2(dto: GetCheckInListFilter) {
  return axios.post<ResponseObjectPaginated<GetCheckInListFilter[]>>(
    `${BASEURL}/reserve/postListBeds`,
    dto,
  )
}

export function getListReservasHuesped(dto: GetCheckInListFilter) {
  return axios.post<ResponseObjectPaginated<GetCheckInListFilter[]>>(
    `${BASEURL}/reserve/getListReservasHuesped`,
    dto,
  )
}

export function searchGuestService(dto: SearchHuespedModel) {
  return axios.post<ResponseObjectPaginated<GuestModel[]>>(`${BASEURL}/guest/getList`, {
    ...dto,
    size: 200,
    pageNumber: 1,
  })
}

export function getListReservaCamaProductoTipoHuesped(
  dto: GetListReservaCamaProductoTipoHuespedDto,
) {
  return axios.post<ResponseObjectPaginated<ReservaCamaProductoTipoHuespedModel[]>>(
    `${BASEURL}/reserve/getListReservaCamaProductoTipoHuesped`,
    dto,
  )
}

export function getproductTypeGuest(dto: any) {
  return axios.post<ResponseObjectPaginated<any[]>>(`${BASEURL}/productTypeGuest/getList`, dto)
}

export async function createReserveBedProductTypeGuestService(
  dto: createReserveBedProductTypeGuest,
) {
  return await axios.post<ResponseObject<any>>(
    `${BASEURL}/reserve/createReserveBedProductTypeGuest`,
    dto,
  )
}

export async function deleteReserveBedProductTypeGuestService(listaReserveId: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<any>>(
    `${BASEURL}/reserve/deleteReserveBedProductTypeGuest`,
    {data: listaReserveId},
  )
}

export function getTemplateCheckInService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/reserve/downloadTemplateBulkLoadCheckIn`)
}

export function uploadTemplateCheckInService(test: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/reserve/bulkLoadCheckIn`, test)
}

export function getTemplateCheckOutService() {
  return axios.post<ResponseObjectURL>(`${BASEURL}/reserve/downloadTemplateBulkLoadCheckOut`)
}

export function uploadTemplateCheckOutService(test: any) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/reserve/bulkLoadCheckOut`, test)
}

export function uploadSignatureGuestService(test: any, guestId: string) {
  return axios.post<ResponseObjectUpload>(
    `${BASEURL}/guest/saveSignatureTyC?guestId=${guestId}`,
    test,
  )
}
